import {Injectable} from '@angular/core';
import {BaseService, QueryParams} from '../../../../core/abstracts/base-service.abstract';
import {ReadableAll} from '../../../../core/interfaces/base-service.interfaces';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VehicleCategoryResponse} from '../models/vehicle-category-response.model';

@Injectable({providedIn: 'root'})
export class VehicleCategoryService extends BaseService implements ReadableAll<VehicleCategoryResponse> {
  protected override readonly endpoint: string = '/categories';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  getAll(params?: QueryParams): Observable<VehicleCategoryResponse[]> {
    return this.get<VehicleCategoryResponse[]>('', params);
  }
}
